import { useEffect, useRef } from "react"
import { Fade } from "react-slideshow-image"
import "react-slideshow-image/dist/styles.css"

const HomeImageSwitcher = () => {
  const containerRef = useRef<any>(null)
  const slideRef = useRef<any>(null)

  const handleScroll = () => {
    const containerElement = containerRef.current
    if (!containerElement) return

    const rect = containerElement.getBoundingClientRect()
    const isWithin300px = rect.top >= 0 && rect.top <= 300

    if (isWithin300px) {
      slideRef.current.goNext() // 开始幻灯片
    }
  }

  useEffect(() => {
    window.addEventListener("scroll", handleScroll)

    return () => {
      window.removeEventListener("scroll", handleScroll)
    }
  }, [])
  return (
    <div
      ref={containerRef}
      className="relative mx-auto mb-[120px] hidden w-[1360px] max-w-full lg_block"
    >
      <Fade
        ref={slideRef}
        autoplay={false}
        infinite={false}
        arrows={false}
        canSwipe={true}
        duration={3000}
      >
        <div className="relative h-full w-full">
          <img src="/images/home-image-switcher-1.webp" />
          <div className="absolute left-[120px] top-[100px] max-w-[720px]">
            <h2 className="mb-[24px] text-[48px] font-[700] leading-[58px] text-white">
              Treat hummingbirds in summer,
            </h2>
          </div>
        </div>

        <div className="relative h-full w-full">
          <img src="/images/home-image-switcher-2.webp" />
          <div className="absolute left-[120px] top-[100px] max-w-[720px]">
            <h2 className="mb-[24px] text-[48px] font-[700] leading-[58px] text-white">
              Treat hummingbirds in summer,
            </h2>
            <p
              className={`duration-2000 mb-[24px] transform  text-[48px] font-[700] leading-[58px] text-[#EE6C4D] transition-all`}
            >
              feed locals as winter whispers.
            </p>
            <p
              className={`duration-2000 inline-block transform  rounded-[12px] bg-[#A7C957] px-[16px] text-[24px] leading-[45px] text-white transition-all`}
            >
              Replaceable feeder.
            </p>
          </div>
        </div>
      </Fade>
    </div>
  )
}

export default HomeImageSwitcher
